import Vue from 'vue'
import Vuex from 'vuex'

require('es6-promise').polyfill()

Vue.use(Vuex)

import * as actions from './actions'
import system from './modules/system'
import account from './modules/account'
import sport from './modules/sport'
import sportResult from './modules/sport-result'
import sportOutright from './modules/sport-outright'
import bet from './modules/bet'
import forecast from './modules/forecast'
import sportMiniBet from './modules/sport-minibet'
import sportLeague from './modules/sport-league'
import statement from './modules/statement'
import liveChannel from './modules/live-channel'
import promotion from './modules/promotion'


export default new Vuex.Store({
  actions,
  modules: [
    system,
  	account,
    sport,
    sportResult,
    sportOutright,
    bet,
    forecast,
    sportMiniBet,
    statement,
    sportLeague,
    liveChannel,
    promotion,
  ]
})



// WEBPACK FOOTER //
// ./resources/wob/vue/store/index.js